import Repository from "@shared/services/api/abstracts/Repository";
import { UrlRouteMap } from "@shared/services/api/types";
import { UserBasedWaitlistSubscriberSerializer } from "../types/user-waitlist-types";

export default class UserBasedWaitlistSubscriberRepository extends Repository<UserBasedWaitlistSubscriberSerializer> {
  public readonly repositoryName = "UserBasedWaitlistSubscriberRepository";

  public readonly endpoint = "api/user/tickets/waitlist-subscriber";

  public get urlMap(): UrlRouteMap {
    return {
      ...this.defaultUrlMap,
      cancelWaitlist: "{waitlist_id}/cancel",
    };
  }

  public async cancelWaitlist(waitlist_id: number): Promise<void> {
    await this.request(this.buildUrl("cancelWaitlist", { waitlist_id }), {
      method: "post",
    });
  }
}
